import { find } from 'lodash';

import { BreadcrumbItem } from '@components/Breadcrumb';
import { PRIMARY_MARKETS } from '@/constants/markets';
import { PRIMARY_INDUSTRIES } from '@/constants/industries';
import {
  ROUTE_COMPANY,
  ROUTE_STOCKS_HOME,
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';

export const makeBreadcrumbsFromCanonicalUrl = ({
  companyName,
  canonicalUrl,
}: {
  canonicalUrl: string;
  companyName: string;
}): BreadcrumbItem[] => {
  const companyCanonicalUrlRegex =
    /^\/stocks\/([a-z]{2})\/([a-z, -]+)\/([a-z0-9,-]+)\/([a-z0-9,-]+)$/;
  const match = canonicalUrl.match(companyCanonicalUrlRegex);
  if (match === null) {
    return [];
  }
  const [_, market, industry, exchangeTicker, name] = match;

  const readableCountry = PRIMARY_MARKETS[market]?.label || 'Global';
  const primaryIndustry = find(PRIMARY_INDUSTRIES, {
    slug: industry as (typeof PRIMARY_INDUSTRIES)[keyof typeof PRIMARY_INDUSTRIES]['slug'],
  });
  return [
    {
      name: 'Stocks',
      canonicalUrl: '/stocks',
      dispatch: {
        type: ROUTE_STOCKS_HOME,
        payload: {},
      },
    },
    {
      name: readableCountry,
      canonicalUrl: `/stocks/${market}`,
      dispatch: {
        type: ROUTE_STOCKS_MARKET,
        payload: {
          market,
        },
      },
    },
    ...(typeof primaryIndustry !== 'undefined'
      ? [
          {
            name: primaryIndustry.label,
            canonicalUrl: `/stocks/${market}/${industry}`,
            dispatch: {
              type: ROUTE_STOCKS_MARKET_INDUSTRY,
              payload: {
                market: market,
                industry: industry,
              },
            },
          },
        ]
      : []),
    {
      name: companyName,
      canonicalUrl: canonicalUrl,
      dispatch: {
        type: ROUTE_COMPANY,
        payload: {
          isoCode2: market,
          industry: industry,
          exchange_ticker: exchangeTicker,
          companyname: name,
        },
      },
    },
    {
      name: 'Narrative',
    },
  ];
};
